'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactRedux = require('react-redux');

var _tmtUiKit = require('tmt-ui-kit');

var _session = require('redux/modules/session');

var _helpers = require('utils/helpers');

var _experienceDestinations = require('json/experience-destinations.json');

var _experienceDestinations2 = _interopRequireDefault(_experienceDestinations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Nav: {
    displayName: 'Nav'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/Nav.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var optionDestinations = (0, _keys2.default)(_experienceDestinations2.default.en).map(function (key) {
  var optionItem = _experienceDestinations2.default.en[key].map(function (option) {
    return { value: (0, _stringify2.default)(option), label: option.label };
  });
  return {
    group: key,
    items: optionItem
  };
});

var services = JSON.parse('[{"label":"4G Sim Card","url":"/trip/happy-tourist-sim-card-8-days"},{"label":"Airport - Hotel Private Transfer","url":"/article/private-airport-transfers-ferries-van-car-rentals"},{"label":"Airport Luggage","url":"/article/luggage-deposit-and-delivery-services"},{"label":"Attraction Ticket","url":"/article/thailand-attraction-ticket-travel-product"},{"label":"Spa Treatment / Massage","url":"/ticket/perception-blind-massage-in-bangkok"},{"label":"Private Tuk-Tuk Rides","url":"/trip/1-day-unlimited-private-tuk-tuk-rides-bangkok-old-town"},{"label":"1-Day Chao Phraya Boat Pass","url":"/ticket/1-day-pass-chao-phraya-hop-on-hop-off-boat"},{"label":"Bangkok Hop-on Hop-off Bus Tour","url":"/ticket/20-off-elephant-go-go-hop-on-hop-off-bus-tour"}]');

var optionServices = services.map(function (option) {
  return {
    label: option.label,
    value: (0, _stringify2.default)(option)
  };
});

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__Container',
  componentId: 'sc-dkj32k-0'
})(['position:fixed;top:0px;width:100%;z-index:4000;background:', ';transition:top 0.5s ease-in-out;'], function (props) {
  return props.theme.white;
});

var enhance = (0, _reactRedux.connect)(function (state) {
  return {
    isPartnerConfigLoaded: state.app.isPartnerConfigLoaded,
    affId: state.app.affId,
    partnerConfig: state.app.partnerConfig,
    sessionData: state.session.data,
    isLoggedIn: state.session.isLoggedIn,
    user: state.session.user,
    isOpenMobileMenu: state.session.isOpenMobileMenu,
    isOpenLogin: state.session.isOpenLogin,
    toasts: state.toast.toasts,
    isSessionDataLoaded: state.session.userDataLoaded && !state.session.loadingSessionData,
    locale: 'en',
    seenZone: state.home.seenZone
  };
}, {
  setSessionData: _session.setSessionData,
  loadSessionData: _session.loadSessionData,
  openLoginSignup: _session.openLoginSignup,
  goBack: _reactRouterRedux.goBack,
  push: _reactRouterRedux.push
});

var Nav = _wrapComponent('Nav')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(Nav, _Component);

  function Nav(props) {
    (0, _classCallCheck3.default)(this, Nav);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Nav.__proto__ || (0, _getPrototypeOf2.default)(Nav)).call(this, props));

    _this.onChangeCurrency = _this.onChangeCurrency.bind(_this);

    if (!(typeof _this.onChangeCurrency === 'function')) {
      throw new TypeError('Value of "this.onChangeCurrency" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeCurrency));
    }

    _this.getLabel = _this.getLabel.bind(_this);

    if (!(typeof _this.getLabel === 'function')) {
      throw new TypeError('Value of "this.getLabel" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.getLabel));
    }

    _this.onChangeDestination = _this.onChangeDestination.bind(_this);

    if (!(typeof _this.onChangeDestination === 'function')) {
      throw new TypeError('Value of "this.onChangeDestination" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDestination));
    }

    _this.clickCall = _this.clickCall.bind(_this);

    if (!(typeof _this.clickCall === 'function')) {
      throw new TypeError('Value of "this.clickCall" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.clickCall));
    }

    _this.getActivePage = _this.getActivePage.bind(_this);

    if (!(typeof _this.getActivePage === 'function')) {
      throw new TypeError('Value of "this.getActivePage" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.getActivePage));
    }

    _this.onChangeService = _this.onChangeService.bind(_this);

    if (!(typeof _this.onChangeService === 'function')) {
      throw new TypeError('Value of "this.onChangeService" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeService));
    }

    _this.getLabelService = _this.getLabelService.bind(_this);

    if (!(typeof _this.getLabelService === 'function')) {
      throw new TypeError('Value of "this.getLabelService" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.getLabelService));
    }

    _this.isPaymentPage = false;
    return _this;
  }

  (0, _createClass3.default)(Nav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkIsPaymentPage(this.props.url.pathname);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextProps) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.isSessionDataLoaded !== nextProps.isSessionDataLoaded)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', true);

              case 2:
                if (!(this.props.isLoggedIn !== nextProps.isLoggedIn)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', true);

              case 4:
                if (!(this.props.sessionData.currency !== nextProps.sessionData.currency)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', true);

              case 6:
                if (!(this.props.seenZone !== nextProps.seenZone)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', true);

              case 8:
                if (!(this.props.url.pathname !== nextProps.url.pathname)) {
                  _context.next = 11;
                  break;
                }

                this.checkIsPaymentPage(nextProps.url.pathname);
                return _context.abrupt('return', true);

              case 11:
                return _context.abrupt('return', false);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function shouldComponentUpdate(_x) {
        return _ref.apply(this, arguments);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'onChangeCurrency',
    value: function onChangeCurrency(e) {
      e.target.blur();
      this.props.setSessionData({ currency: e.target.value }, true);
    }
  }, {
    key: 'onChangeDestination',
    value: function onChangeDestination(e) {
      // eslint-disable-line
      var _JSON$parse = JSON.parse(e.target.value),
          url = _JSON$parse.url;

      window.location.href = url;
    }
  }, {
    key: 'onChangeService',
    value: function onChangeService(e) {
      var _JSON$parse2 = JSON.parse(e.target.value),
          url = _JSON$parse2.url;

      this.props.push(url);
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      var url = this.props.url;

      var city = url && url.query && url.query.city || null;
      if (city) return (0, _helpers.getCity)(city);
      return 'Where to go?';
    }
  }, {
    key: 'getLabelService',
    value: function getLabelService() {
      var url = this.props.url;

      var city = url && url.query && url.query.city || null;
      if (city) return (0, _helpers.getCity)(city);
      return 'Travel Products';
    }
  }, {
    key: 'getActivePage',
    value: function getActivePage() {
      var _props = this.props,
          url = _props.url,
          seenZone = _props.seenZone;

      if (url && url.pathname !== '/home') {
        switch (url.pathname) {
          case '/article/article':
            return 'travel-guides';
          default:
            return url.pathname.replace('/', '');
        }
      }
      if (!seenZone) return '';
      var element = (0, _keys2.default)(seenZone).find(function (key) {
        return seenZone[key];
      });
      return element || '';
    }
  }, {
    key: 'checkIsPaymentPage',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(path) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!path.match(/^\/booking(?!.*\/success).*$/)) {
                  _context2.next = 4;
                  break;
                }

                this.isPaymentPage = true;
                _context2.next = 8;
                break;

              case 4:
                if (!path.match(/^\/booking(.*\/success).*$/)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return this.props.loadSessionData();

              case 7:
                this.isPaymentPage = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkIsPaymentPage(_x2) {
        return _ref2.apply(this, arguments);
      }

      return checkIsPaymentPage;
    }()
  }, {
    key: 'clickCall',
    value: function clickCall() {
      this.props.clickCall();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          sessionData = _props2.sessionData,
          user = _props2.user,
          url = _props2.url,
          affId = _props2.affId;

      var selectedDestination = this.getLabel();
      var selectedService = this.getLabelService();
      var page = this.getActivePage();
      var affiliateId = (url.query || {}).affid || affId || undefined;
      var isTGTHAffiliate = affiliateId === _config2.default.tgthAffiliateId;
      var isTGTHUser = !!user.tgth_uuid;
      var hideMainMenus = isTGTHAffiliate || isTGTHUser;
      var centerLogoOnMobile = isTGTHAffiliate || isTGTHUser;
      var alwaysHidePoweredByLogo = isTGTHAffiliate || isTGTHUser;
      var alwaysHideSupportButton = isTGTHAffiliate || isTGTHUser;
      var showBackButton = isTGTHAffiliate || isTGTHUser;
      return _react3.default.createElement(
        Container,
        null,
        _react3.default.createElement(_tmtUiKit.Nav.Navbar, {
          hideMenu: !this.props.isSessionDataLoaded || this.isPaymentPage
          // Dropdown Travels
          , selectedDestination: selectedDestination,
          optionDestinations: optionDestinations,
          placeholder: 'Where to go ?',
          onChangeDestination: this.onChangeDestination

          // Dropdown Currency
          , optionCurrencies: _helpers.currencies,
          selectedCurrency: sessionData.currency,
          currencyLabel: sessionData.currency,
          onChangeCurrency: this.onChangeCurrency,

          otherServices: optionServices,
          onChangeService: this.onChangeService,
          selectedService: selectedService

          // Link button
          // helpcenterButtonContainer={<a href="https://takemetoursupport.zendesk.com/hc/en-us" target="_blank" rel="noopener noreferrer" />}
          , logoButtonContainer: _react3.default.createElement(_Link2.default, { to: '/' })
          // listyourtripButtonContainer={this.props.user.is_local_expert ? <Link to="/dashboard/listing" /> : <a href="/local-expert-benefits" />}
          , onClickSignup: function onClickSignup() {
            return _this2.props.openLoginSignup(true, 'signup');
          },
          onClickLogin: function onClickLogin() {
            return _this2.props.openLoginSignup(true, 'login');
          },
          isLoggedIn: this.props.isLoggedIn,
          user: user,
          navLink: {
            editProfile: _react3.default.createElement(_Link2.default, { to: '/dashboard/profile' }),
            signUp: _react3.default.createElement('a', { onClick: function onClick() {
                return _this2.props.openLoginSignup(true, 'signup');
              } }),
            logIn: _react3.default.createElement('a', { onClick: function onClick() {
                return _this2.props.openLoginSignup(true, 'login');
              } }),
            dashboard: _react3.default.createElement(_Link2.default, { to: '/dashboard' }),
            wishlist: _react3.default.createElement(_Link2.default, { to: '/dashboard?section=wishlist' }),
            trustAndSafety: _react3.default.createElement(_Link2.default, { to: '/trust-and-safety' }),
            bookings: _react3.default.createElement(_Link2.default, { to: '/dashboard/booking' }),
            message: _react3.default.createElement(_Link2.default, { to: '/dashboard/booking' }),
            addOns: _react3.default.createElement(_Link2.default, { to: '/dashboard/service' }),
            getFreeTrip: _react3.default.createElement(_Link2.default, { to: '/dashboard/referral' }),
            helpCenter: _react3.default.createElement(_Link2.default, { to: '/help-center' }),
            verification: _react3.default.createElement(_Link2.default, { to: '/dashboard/verification' }),
            logOut: _react3.default.createElement(_Link2.default, { to: '/logout' }),
            contact: _react3.default.createElement(_Link2.default, { to: '/contact' }),
            travelGuides: _react3.default.createElement(_Link2.default, { to: '/article' }),
            listing: this.props.user.is_local_expert ? _react3.default.createElement(_Link2.default, { to: '/dashboard/listing' }) : _react3.default.createElement('a', { href: '/local-expert-benefits' }),
            otherServices: _react3.default.createElement('a', { href: 'https://www.takemetour.com#other-services' }),
            wallet: _react3.default.createElement(_Link2.default, { to: '/dashboard/wallet' }),
            availability: _react3.default.createElement(_Link2.default, { to: '/dashboard/availability' }),
            findTrips: _react3.default.createElement(_Link2.default, { to: '/explore/Bangkok' }),
            setting: _react3.default.createElement(_Link2.default, { to: '/dashboard/settings' }),
            community: _react3.default.createElement(_Link2.default, { to: '/local-expert-community', target: '_blank', rel: 'noopener noreferrer' }),
            deals: _react3.default.createElement(_Link2.default, { to: '/promotions' })
          },
          socialLink: {
            faceBookLink: _react3.default.createElement('a', { href: 'https://www.facebook.com/Takemetour/', target: '_blank', rel: 'noopener noreferrer' }),
            instagramLink: _react3.default.createElement('a', { href: 'https://www.instagram.com/takemetour_thailand/', target: '_blank', rel: 'noopener noreferrer' }),
            pinterestLink: _react3.default.createElement('a', { href: 'https://www.pinterest.com/TakeMeTour/', target: '_blank', rel: 'noopener noreferrer' })
          },
          whatAppsButtonContainer: _react3.default.createElement('a', { href: 'https://api.whatsapp.com/send?phone=66830761452', onClick: this.clickCall }),
          page: page,
          messageCount: user.messageCount,
          bookingCount: user.bookingCount,
          affiliateDetail: this.props.partnerConfig ? this.props.partnerConfig.logos : undefined,
          hideLogo: !this.props.isPartnerConfigLoaded,
          centerLogoOnMobile: centerLogoOnMobile,
          hideMainMenus: hideMainMenus,
          showBackButton: showBackButton,
          alwaysHidePoweredByLogo: alwaysHidePoweredByLogo,
          alwaysHideSupportButton: alwaysHideSupportButton,
          onBackButtonClick: this.props.goBack
        })
      );
    }
  }]);
  return Nav;
}(_react2.Component), _class.propTypes = {
  // isWhite: PropTypes.bool,
  // hideMenu: PropTypes.bool,
  // fullWidth: PropTypes.bool,
  // isOpenMobileMenu: PropTypes.bool,
  // locale: PropTypes.string,
  affId: _propTypes2.default.string,
  partnerConfig: _propTypes2.default.object,
  url: _propTypes2.default.any,
  sessionData: _propTypes2.default.object,
  // clickCall: PropTypes.func,
  openLogin: _propTypes2.default.func,
  openSignup: _propTypes2.default.func,
  setSessionData: _propTypes2.default.func,
  loadSessionData: _propTypes2.default.func,
  clickCall: _propTypes2.default.func,
  isSessionDataLoaded: _propTypes2.default.bool,
  // openMobileMenu: PropTypes.func,
  // toasts: PropTypes.array,
  isLoggedIn: _propTypes2.default.bool,
  user: _propTypes2.default.object,
  seenZone: _propTypes2.default.object,
  openLoginSignup: _propTypes2.default.func,
  goBack: _propTypes2.default.func,
  push: _propTypes2.default.func
}, _class.defaultProps = {
  url: {
    pathname: '/'
  }
}, _temp));

exports.default = enhance(Nav);

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Nav.js
// module id = 668
// module chunks = 47